<div class="row summary px-3 py-4 m-0" [ngClass]="summary ? 'summary-' + summary.masterProductStatus.code : ''">
    <div *ngIf="!summary" class="row w-100 mx-0" style="min-height: 100px;">
        <div class="col-12 text-center">
            <lib-loading [status]="'text-white'" [spinnerPosition]="true" [text]="'LDG'" [size]="'md'"></lib-loading>
        </div>
    </div>

    <div *ngIf="summary" class="row m-0 w-100 d-flex flex-column flex-md-row" style="min-height: 100px;">
        <div class="col-3 col-xl-2 mx-auto mx-md-0">
            <ng-container *ngIf="summary.imageUrl; else validURL">
                <img class="img-fluid image-hover" [src]="summary.imageUrl" [alt]="summary.partNumber" (click)="openImageModal()">
            </ng-container>
            <ng-template #validURL>
                <img class="img-fluid" [src]="summary.imageUrl" [alt]="summary.partNumber">
            </ng-template>
        </div>
        <div class="col-12 col-md-9 col-xl-10 px-0">
            <div class="col-12 d-flex flex-column flex-xl-row mb-2 px-0">
                <div class="col-12 col-xl-5 px-0 text-center text-md-left">
                    <div class="col-12 px-0 pr-md-3 pb-2">
                        <h1 class="mb-0 h2">{{ summary.partNumber }} - {{ summary.shortTitle }}</h1>
                    </div>
                    <div class="col-12 px-0 pr-md-3">
                        <div *ngIf="showDataDashboard">
                            <app-product-master-status [masterProductStatus]="summary.masterProductStatus" [supersessions]="summary.superSessions"></app-product-master-status>
                        </div>
                        <div *ngIf="showSalesDashboard" class="d-flex">
                            <app-stock-status-indicator class="mr-2" [stockLevels]="summary.stockLevels" [branch]="branch"></app-stock-status-indicator>
                            <lib-product-type-indicator [productType]="summary.productType.code"></lib-product-type-indicator>
                        </div>
                    </div>
                </div>
                <!-- data team dashboard -->
                <div *ngIf="showDataDashboard" class="data-container col-12 col-xl-7 px-0 mt-4 mt-xl-0 pr-xl-3 text-center text-xl-right">
                    <ng-container *ngIf="productMasterStatuses; else noStatuses">
                        <ng-container *ngFor="let status of productMasterStatuses">
                            <button  [id]="status.code" *ngIf="!status.disabled && status.actionTitle" (click)="processStatus(status)"
                                class="btn custom-btn ml-3 mb-3 {{ categorisedClass(status) }}">
                                {{ status.actionTitle }}
                            </button>
                        </ng-container>
                    </ng-container>
                    <ng-template #noStatuses>
                        <p class="mb-0 text-muted">No Master Product Statuses are currently available for this product.</p>
                    </ng-template>
                </div>
                <!-- sales dashboard - expand / minimise button & functionality hidden for now using [hidden] attr below -->
                <div *ngIf="showSalesDashboard" class="sales-container col-12 col-xl-7 text-right" [hidden]="true">
                    <button *ngIf="!showPartDetails" class="btn d-inline-flex align-items-center" (click)="toggleShowPartDetails()">
                        <!-- Expand Summary -->
                        <div class="d-flex flex-column ml-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-short" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 
                                    0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-short" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 
                                    1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
                            </svg>
                        </div>
                    </button>
                    <button *ngIf="showPartDetails" class="btn d-inline-flex align-items-center" (click)="toggleShowPartDetails()">
                        <!-- Minimise Summary -->
                        <div class="d-flex flex-column ml-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-short" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 
                                    1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5A.5.5 0 0 1 8 4z"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-short" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 
                                    0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"/>
                            </svg>
                        </div>
                    </button>
                </div>
            </div>
            <!-- product desc -->
            <div class="col-12 px-0 pr-md-3" *ngIf="summary.shortDescription">
                <p class="comment mb-0 text-center text-md-left">
                    {{ summary.shortDescription }}
                </p>
            </div>
            <!-- internal comment -->
            <div class="col-12 px-0 pr-md-3 pt-4" *ngIf="summary.internalComment">
                <small class="text-muted h6">INTERNAL COMMENT</small>
                <p class="comment text-center text-md-left my-1 font-bold font-italic">{{ summary.internalComment }}</p>
            </div>
        </div>

        <!-- summary (toggles on/off) -->
        <div [hidden]="!showPartDetails" class="row px-md-3 mt-5 m-0 part-summary w-100">
            <div class="col-12 col-xl-4 px-0 mb-2">
                <div class="row mb-2">
                    <div class="col-4 text-muted">Part No:</div>
                    <div class="col-8 pl-0">{{ summary.partNumber }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col-4 text-muted">Base Part No:</div>
                    <div class="col-8 pl-0">{{ summary.basePartNumber }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col-4 text-muted">Brand:</div>
                    <div class="col-8 pl-0">{{ summary.brand.name }}</div>
                </div>
                <div class="row mb-2">
                    <div class="col-4 text-muted">Type:</div>
                    <div class="col-8 pl-0">{{ summary.productType.name }}</div>
                </div>
                <div class="row">
                    <div class="col-4 text-muted">Core(Noos):</div>
                    <div class="col-8 pl-0">
                        <ng-container *ngIf="summary.branchInfo.isCoreProduct; else fallback">Yes</ng-container>
                        <ng-template #fallback>No</ng-template>
                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-4 px-0">
                <div class="row mx-0">
                    <div class="col-12 text-muted mb-2 pl-0">Quantity Available</div>
                </div>
                <ng-container *ngFor="let b of summary.stockLevels">
                    <div class="row mx-0 mb-2">
                        <div class="col-3 pl-0 pr-xl-0 text-muted text-xl-right">{{ b.branch.code }}:</div>
                        <div class="col-9 pl-0 pl-xl-3">{{ b.quantityAvailable }}</div>
                    </div>
                </ng-container>                
            </div>
            <div class="col-12 col-xl-4 px-0">
                <div class="row mx-0 mb-2">
                    <div class="col-3 pl-0 pr-xl-0 text-muted">Avg Cost Price:</div>
                    <div class="col-9 pl-0 pl-xl-3">
                        {{ summary.branchInfo.averageCostPrice | currency:  currencyCode}}
                    </div>
                </div>
                <div class="row mx-0 mb-2" *ngIf="showIntraGroupPrice">
                    <div class="col-3 pl-0 pr-xl-0 text-muted">Intra Group Price:</div>
                    <div class="col-9 pl-0 pl-xl-3">
                        {{ intraGroupPrice | currency:  currencyCode}}
                    </div>
                </div>
                <div class="row mx-0 mb-2">
                    <div class="col-3 pl-0 pr-xl-0 text-muted">Retail Price:</div>
                    <div class="col-9 pl-0 pl-xl-3">
                        {{ summary.branchInfo.retailPrice | currency:  currencyCode}}
                    </div>
                </div>
                <div class="row mx-0 mb-2">
                    <div class="col-3 pl-0 pr-xl-0 text-muted">Surcharge:</div>
                    <div class="col-9 pl-0 pl-xl-3">
                        {{ summary.branchInfo.surcharge | currency:  currencyCode }}
                    </div>
                </div>
                <div class="row mx-0">
                    <div class="col-3 pl-0 pr-xl-0 text-muted">Unit Price:</div>
                    <ng-container *ngFor="let unitPrice of summary.branchInfo.unitPrice">
                        <div class="col-9 pl-0 pl-xl-3" *ngIf="unitPrice.discountLevel.name === 'Retail'">
                            {{ unitPrice.price | currency:  currencyCode}}
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <ng-template #superceded let-tab>
        <app-supersede-product [productId]="productId" [product]="product ? product: undefined"
            (formEmitter)="assignForm($event)">
        </app-supersede-product>
    </ng-template>
</div>

<ng-template class="modal-lg" let-modal #imageModal>
    <div class="modal-header d-flex align-items-center">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 
            2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body p-3 text-center">
        <ng-container *ngIf="modalBusy; else loaded">
            <lib-loading [status]="'text-primary'" [spinnerPosition]="true" [text]="" [size]="'md'"></lib-loading>
        </ng-container>
        <ng-template #loaded>
            <ng-container *ngIf="imageUrl750px; else fb">
                <img class="w-100" [src]="imageUrl750px" [alt]="summary.partNumber">
            </ng-container>
            <ng-template #fb>
                Image not available to be previewed
            </ng-template>
        </ng-template>
    </div>
</ng-template>